// @core/api/endpoints/user/check_user_exists.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CheckUserExistsRequest,
  CheckUserExistsResponse,
} from '../../../types/user';

const BASE_PATH = '/user';

/**
 * Check if user exists
 * Checks whether a user with the given email or username already exists. No authz — service-to-service only.
 */
export async function CheckUserExists(
  data: CheckUserExistsRequest,
  options?: RequestOptions
): Promise<CheckUserExistsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/internal/check-exists`;
  const requestOptions = options;
  return client.post<CheckUserExistsResponse>(requestPath, data, requestOptions);
}
